import "./Experience.css";

export default function Experience({ name = "Tech Name", level = "Beginner", image = "" }) {
  const levelClass = level.toLowerCase().replace(/\s+/g, "-");
  return (
    <div className={`experience-card level-${levelClass}`}>
      <div className="exp-icon-wrap">
        <img src={`./assets/experience/${image}`} alt={name} loading="lazy" />
      </div>
      <div className="exp-body">
        <h3 className="exp-name">{name}</h3>
        <span className="exp-level">{level}</span>
      </div>
      <div className="exp-hover-glow" aria-hidden />
    </div>
  );
}
